import { useMemo } from "react";
import { useAppSelector } from "./store";
import { getCurrentUser } from "../reducer/authSlice";

function useAuth() {
  const user = useAppSelector(getCurrentUser);

  return useMemo(() => user, [user]);
}

export default useAuth;
